<template>
  <div>
    <v-app-bar
      id="app-bar"
      fixed
      app
      elevation="0"
      height="68"
      class="app-bar-modern"
    >
      <!-- Menu Toggle -->
      <v-btn
        icon
        small
        class="menu-toggle mr-2"
        @click="setDrawer(!drawer)"
      >
        <v-icon size="22" color="#475569">
          {{ value ? 'mdi-view-quilt' : 'mdi-menu' }}
        </v-icon>
      </v-btn>

      <!-- Route Title -->
      <v-toolbar-title class="hidden-sm-and-down route-title">
        {{ $route.name }}
      </v-toolbar-title>

      <v-spacer />

      <!-- Notification Bell -->
      <v-menu
        v-model="notificationMenu"
        offset-y
        left
        :close-on-content-click="false"
        max-width="420"
        min-width="380"
        nudge-bottom="8"
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="notification-btn mr-2"
          >
            <v-badge
              :content="String(activeAlertCount)"
              :value="activeAlertCount > 0"
              color="error darken-1"
              overlap
              offset-x="10"
              offset-y="10"
            >
              <v-icon
                size="24"
                :color="activeAlertCount > 0 ? 'info darken-3' : 'grey'"
                :class="{ 'bell-ring': activeAlertCount > 0 }"
              >
                {{ activeAlertCount > 0 ? 'mdi-bell' : 'mdi-bell-outline' }}
              </v-icon>
            </v-badge>
          </v-btn>
        </template>

        <!-- Notification Dropdown Panel -->
        <v-card class="notification-panel" elevation="8">
          <!-- Panel Header -->
          <div class="panel-header">
            <div class="panel-header-left">
              <v-icon size="20" color="info darken-3" class="mr-2">mdi-bell</v-icon>
              <span class="panel-title">การแจ้งเตือน</span>
            </div>
            <v-chip
              v-if="activeAlertCount > 0"
              x-small
              color="info lighten-5"
              text-color="info darken-3"
              class="font-weight-bold"
            >
              {{ activeAlertCount }} รายการ
            </v-chip>
          </div>

          <v-divider></v-divider>

          <!-- Notification List -->
          <div class="notification-list" v-if="activeAlerts.length > 0">
            <div
              v-for="(alert, index) in activeAlerts"
              :key="index"
              class="notification-item"
              @click="scrollToAlert(alert)"
            >
              <div
                class="noti-priority-indicator"
                :class="alert.priority"
              ></div>
              <div
                class="noti-icon-wrap"
                :style="{ background: alert.iconBg }"
              >
                <v-icon size="18" color="white">{{ alert.icon }}</v-icon>
              </div>
              <div class="noti-body">
                <div class="noti-title-row">
                  <span class="noti-title">{{ alert.title }}</span>
                  <v-chip
                    x-small
                    :color="getPriorityColor(alert.priority)"
                    dark
                    class="noti-priority-chip"
                  >
                    {{ getPriorityLabel(alert.priority) }}
                  </v-chip>
                </div>
                <div class="noti-deadline" v-if="alert.deadline">
                  <v-icon x-small color="error" class="mr-1">mdi-clock-outline</v-icon>
                  ปิดระบบ: {{ alert.deadline }}
                </div>
              </div>
              <v-icon size="16" color="grey" class="noti-arrow">mdi-chevron-right</v-icon>
            </div>
          </div>

          <!-- Empty State -->
          <div v-else class="notification-empty">
            <v-icon size="48" color="grey lighten-1">mdi-bell-check-outline</v-icon>
            <p class="mt-3 grey--text">ไม่มีการแจ้งเตือนขณะนี้</p>
          </div>

          <!-- Panel Footer -->
          <template v-if="activeAlerts.length > 0">
            <v-divider></v-divider>
            <div class="panel-footer">
              <v-btn
                text
                small
                color="info darken-3"
                class="view-all-btn"
                @click="notificationMenu = false"
              >
                <v-icon small left>mdi-arrow-down</v-icon>
                ดูทั้งหมดในหน้าหลัก
              </v-btn>
            </div>
          </template>
        </v-card>
      </v-menu>

      <!-- Organization Branding -->
      <div class="org-brand">
        <v-avatar :size="38" class="org-logo mr-3">
          <img src="ovec.png" alt="สอศ." />
        </v-avatar>
        <div class="org-text hidden-sm-and-down">
          <span class="org-name">ระบบบริหารงานบุคคล</span>
          <span class="org-sub">สำนักงานคณะกรรมการการอาชีวศึกษา</span>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { VHover, VListItem } from "vuetify/lib";
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render: function (h) {
        var self = this;
        return h(VHover, {
          scopedSlots: {
            default: function (ref) {
              var hover = ref.hover;
              return h(
                VListItem,
                {
                  attrs: self.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true
                  }
                },
                self.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      ApiKey: "HRvec2021",
      notificationMenu: false,
      period_colleges: {},
      period_colleges_reportmv: {},
      period_colleges_manpower: {},
      period_college_moves: {},
      period_college_redirector: {},
      period_college_assistantA: {},
      period_sedirector_notice: {},
      period_director_notice: {},
      period_govem: {},
      period_colleges_teach_license: {},
      period_colleges_committee: {},
      period_teacher_govem_manpower_report: {},
      periodassteachs: {}
    };
  },

  mounted: function () {
    this.fetchAllAlerts();
  },

  computed: {
    ...mapState(["drawer"]),

    activeAlerts: function () {
      var self = this;
      var alerts = [];

      if (self.period_college_moves && self.period_college_moves.period_college_enable === "1") {
        alerts.push({
          id: "move_conditions",
          title: "แจ้งเงื่อนไขการย้าย ข้าราชการครู",
          icon: "mdi-swap-horizontal-bold",
          iconBg: "#dc2626",
          priority: "urgent",
          deadline: self.formatDateThai(self.period_college_moves.period_college_stop)
        });
      }

      if (self.period_colleges_committee && self.period_colleges_committee.period_college_enable === "1") {
        alerts.push({
          id: "committee",
          title: "เสนอรายชื่อศึกษานิเทศก์/ผู้ทรงคุณวุฒิ",
          icon: "mdi-account-group",
          iconBg: "#dc2626",
          priority: "urgent",
          deadline: self.formatDateThai(self.period_colleges_committee.period_college_stop)
        });
      }

      if (self.period_colleges_teach_license && self.period_colleges_teach_license.period_college_enable === "1") {
        alerts.push({
          id: "teach_license",
          title: "สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ",
          icon: "mdi-certificate",
          iconBg: "#a86400",
          priority: "urgent",
          deadline: self.formatDateThai(self.period_colleges_teach_license.period_college_stop)
        });
      }

      if (self.period_sedirector_notice && self.period_sedirector_notice.period_sedirector_enable === "1") {
        alerts.push({
          id: "sedirector_notice",
          title: "รายชื่อผู้มีสิทธิคัดเลือก รองผู้อำนวยการ",
          icon: "mdi-account-star",
          iconBg: "#dc2626",
          priority: "urgent",
          deadline: self.formatDateThai(self.period_sedirector_notice.period_sedirector_stop)
        });
      }

      if (self.period_director_notice && self.period_director_notice.period_sedirector_enable === "1") {
        alerts.push({
          id: "director_notice",
          title: "รายชื่อผู้มีสิทธิคัดเลือก ผู้อำนวยการ",
          icon: "mdi-account-tie",
          iconBg: "#dc2626",
          priority: "urgent",
          deadline: self.formatDateThai(self.period_director_notice.period_sedirector_stop)
        });
      }

      if (self.period_college_assistantA && self.period_college_assistantA.period_college_enable === "1") {
        alerts.push({
          id: "assistant_a",
          title: "ประเมิน ภาค ก รองผู้อำนวยการ",
          icon: "mdi-clipboard-check",
          iconBg: "#a86400",
          priority: "high",
          deadline: self.formatDateThai(self.period_college_assistantA.period_college_stop)
        });
      }

      if (self.period_college_redirector && self.period_college_redirector.period_college_enable === "1") {
        alerts.push({
          id: "redirector",
          title: "รับรายงานตัว รองผู้อำนวยการ",
          icon: "mdi-clipboard-account",
          iconBg: "#2e7d32",
          priority: "high",
          deadline: self.formatDateThai(self.period_college_redirector.period_college_stop)
        });
      }

      if (self.period_colleges_reportmv && self.period_colleges_reportmv.period_college_enable === "1" && self.period_colleges_reportmv.period_college_type === "reportmove_teacher") {
        alerts.push({
          id: "reportmv",
          title: "รับรายงานตัว ย้ายกรณีปกติ",
          icon: "mdi-account-arrow-right",
          iconBg: "#b3151b",
          priority: "high",
          deadline: self.formatDateThai(self.period_colleges_reportmv.period_college_stop)
        });
      }

      if (self.periodassteachs && self.periodassteachs.periodAssTeachEnable === "1") {
        alerts.push({
          id: "assteach",
          title: "รับรายงานตัว ครูผู้ช่วย",
          icon: "mdi-school-outline",
          iconBg: "#455a64",
          priority: "high",
          deadline: self.formatDateThai(self.periodassteachs.periodAssTeachStop)
        });
      }

      if (self.period_teacher_govem_manpower_report && self.period_teacher_govem_manpower_report.period_college_enable === "1") {
        alerts.push({
          id: "govem_report",
          title: "รายงานอัตรากำลัง/เบิกจ่าย พนักงานราชการ",
          icon: "mdi-file-document",
          iconBg: "#a86400",
          priority: "high",
          deadline: self.formatDateThai(self.period_teacher_govem_manpower_report.period_college_stop)
        });
      }

      if (self.period_colleges && self.period_colleges.period_college_enable === "1" && self.period_colleges.period_college_type === "update_college") {
        alerts.push({
          id: "manpower",
          title: "รายงานอัตรากำลัง",
          icon: "mdi-chart-bar",
          iconBg: "#b3151b",
          priority: "normal",
          deadline: self.formatDateThai(self.period_colleges.period_college_stop)
        });
      }

      if (self.period_colleges_manpower && self.period_colleges_manpower.period_college_enable === "1") {
        alerts.push({
          id: "vacancy",
          title: "แจ้งสาขาวิชาสำหรับตำแหน่งว่าง",
          icon: "mdi-briefcase-outline",
          iconBg: "#455a64",
          priority: "normal",
          deadline: self.formatDateThai(self.period_colleges_manpower.period_college_stop)
        });
      }

      if (self.period_govem && self.period_govem.period_college_enable === "1") {
        alerts.push({
          id: "govem",
          title: "สำรวจตำแหน่งว่าง พนักงานราชการ",
          icon: "mdi-briefcase",
          iconBg: "#455a64",
          priority: "normal",
          deadline: self.formatDateThai(self.period_govem.period_college_stop)
        });
      }

      return alerts;
    },

    activeAlertCount: function () {
      return this.activeAlerts.length;
    }
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),

    getPriorityColor: function (priority) {
      if (priority === "urgent") return "red darken-1";
      if (priority === "high") return "orange darken-1";
      return "blue";
    },

    getPriorityLabel: function (priority) {
      if (priority === "urgent") return "เร่งด่วน";
      if (priority === "high") return "สำคัญ";
      return "ปกติ";
    },

    scrollToAlert: function (alert) {
      var self = this;
      self.notificationMenu = false;
      self.$nextTick(function () {
        var el = document.getElementById("alert-" + alert.id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.classList.add("highlight-pulse");
          setTimeout(function () {
            el.classList.remove("highlight-pulse");
          }, 2500);
        }
      });
    },

    formatDateThai: function (dateString) {
      if (!dateString) return "";
      var date = new Date(dateString);
      var thaiYear = date.getFullYear() + 543;
      var thaiMonths = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
        "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];
      return date.getDate() + " " + thaiMonths[date.getMonth()] + " " + thaiYear;
    },

    fetchAllAlerts: function () {
      var self = this;
      var endpoints = [
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "401" }, target: "period_college_moves" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "60101" }, target: "period_colleges_committee" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "601" }, target: "period_colleges_teach_license" },
        { url: "period_sedirector.php", params: { ApiKey: self.ApiKey, period_sedirector_enable: "1", period_sedirector_id: "202" }, target: "period_sedirector_notice" },
        // ประกาศรายชื่อผู้มีสิทธิ์ ผอ. — แยกจาก รอง ผอ. (202) ตั้งแต่ 2569-10
        { url: "period_sedirector.php", params: { ApiKey: self.ApiKey, period_sedirector_enable: "1", period_sedirector_id: "302" }, target: "period_director_notice" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "20100" }, target: "period_college_assistantA" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "20101" }, target: "period_college_redirector" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "30102" }, target: "period_colleges_reportmv" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "501" }, target: "period_colleges" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "701" }, target: "period_colleges_manpower" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_id: "801" }, target: "period_govem" },
        { url: "periodassteach.php", params: { ApiKey: self.ApiKey, periodAssTeachEnable: "1", periodAssTeachID: "102" }, target: "periodassteachs" },
        { url: "period_college.php", params: { ApiKey: self.ApiKey, period_college_enable: "1", period_college_id: "80104" }, target: "period_teacher_govem_manpower_report" }
      ];

      endpoints.forEach(function (ep) {
        self.$http.post(ep.url, ep.params)
          .then(function (result) {
            self.$set(self, ep.target, result.data || {});
          })
          .catch(function (err) {
            console.error("Error fetching " + ep.target + ":", err);
            self.$set(self, ep.target, {});
          });
      });
    }
  }
};
</script>

<style scoped>
.app-bar-modern {
  background: #ffffff !important;
  border-bottom: 1px solid #e4e4e7 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
}

.menu-toggle {
  border-radius: 10px !important;
  background: #f5f5f5 !important;
}

.route-title {
  font-size: 0.95rem;
  font-weight: 500;
  color: #475569;
}

.org-brand {
  display: flex;
  align-items: center;
  padding: 6px 12px 6px 8px;
  background: #f5f5f5;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
}

.org-logo {
  border: 2px solid #e4e4e7;
}

.org-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.org-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #263238;
}

.org-sub {
  font-size: 0.7rem;
  color: #94a3b8;
  font-weight: 400;
}

.notification-btn {
  border-radius: 10px !important;
}

.notification-btn:hover {
  background: #f5f5f5 !important;
}

.bell-ring {
  animation: bellSwing 2s ease-in-out infinite;
  transform-origin: top center;
}

@keyframes bellSwing {
  0%, 100% { transform: rotate(0); }
  5% { transform: rotate(12deg); }
  10% { transform: rotate(-10deg); }
  15% { transform: rotate(8deg); }
  20% { transform: rotate(-6deg); }
  25% { transform: rotate(0); }
}

.notification-panel {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid #e4e4e7;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #f5f5f5;
}

.panel-header-left {
  display: flex;
  align-items: center;
}

.panel-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #263238;
}

.notification-list {
  max-height: 420px;
  overflow-y: auto;
}

.notification-list::-webkit-scrollbar {
  width: 3px;
}

.notification-list::-webkit-scrollbar-thumb {
  background: #90a4ae;
  border-radius: 3px;
}

.notification-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
}

.notification-item:hover {
  background: #f5f5f5;
}

.notification-item:hover .noti-arrow {
  color: #b3151b !important;
}

.noti-priority-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
}

.noti-priority-indicator.urgent { background: #dc2626; }
.noti-priority-indicator.high { background: #a86400; }
.noti-priority-indicator.normal { background: #455a64; }

.noti-icon-wrap {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.noti-body {
  flex: 1;
  min-width: 0;
  margin-right: 8px;
}

.noti-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 3px;
}

.noti-title {
  font-size: 0.82rem;
  font-weight: 500;
  color: #263238;
  line-height: 1.35;
  margin-right: 8px;
}

.noti-priority-chip {
  flex-shrink: 0;
  font-size: 0.6rem !important;
  height: 18px !important;
}

.noti-deadline {
  font-size: 0.72rem;
  color: #ef4444;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.noti-arrow {
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.notification-empty {
  padding: 40px 16px;
  text-align: center;
}

.panel-footer {
  padding: 8px 16px;
  text-align: center;
  background: #f5f5f5;
}

.view-all-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  letter-spacing: 0 !important;
}
</style>